import { combineReducers } from '@reduxjs/toolkit'

import { Auth } from './auth';
import { Page } from './page';

export default combineReducers({
	Auth,
	Page
})